import { ShieldCheck, Users, UtilityPole, CalendarCheck } from 'lucide-react';

export const WEB_LINK = {
  title: 'ENERGOSETMONTAJ',
  web_title: 'esm.uz',
  web_url: 'https://esm.uz',
  map_title: 'address',
  map_url:
    'https://yandex.uz/maps/org/137860854542/?display-text=energosetmontaj&from=mapframe&ll=69.575592%2C41.467348&mode=search&sctx=ZAAAAAgBEAAaKAoSCVaA7zZvZ1FAEUZB8Pj2wERAEhIJCRueXinLUD8RrDyBsFOsOj8iBgABAgMEBSgKOABA1IEHSAFqAnV6nQHNzMw9oAEAqAEAvQEio354wgEGjuaWyYEEggIPZW5lcmdvc2V0bW9udGFqigIAkgIAmgIMZGVza3RvcC1tYXBz&sll=69.575592%2C41.467348&source=mapframe&sspn=0.262299%2C0.104198&text=energosetmontaj&utm_source=mapframe&z=13',
  map_view:
    'https://yandex.uz/map-widget/v1/?from=mapframe&ll=69.537633%2C41.429074&mode=search&oid=137860854542&ol=biz&sctx=ZAAAAAgBEAAaKAoSCZc48kBkYlFAEXeHFAMktkRAEhIJMs1jZjarrj8RIq629DL%2Fpj8iBgABAgMEBSgKOABA1IEHSAFiLmJ1c2luZXNzX3VzZV9leHBlcmltZW50YWxfb3JnYW5pY19obnN3X2luZGV4PTFiKHJlbGV2X3JhbmtpbmdfbDFfZm9ybXVsYT1sMV9kYzgwMzIyMV9leHBqAnV6nQHNzMw9oAEAqAEAvQEio354wgEGjuaWyYEEggIPZW5lcmdvc2V0bW9udGFqigIAkgIAmgIMZGVza3RvcC1tYXBz&sll=69.537633%2C41.429074&source=mapframe&sspn=0.003931%2C0.001563&text=energosetmontaj&utm_source=mapframe&z=19.06',
  phone: '+998971308488',
  email: 'info@esm.uz',
  work_hours: '9:00-18:00',

  work_week: {
    time: 'around_the_clock',
  },
  socials: {
    telegram: 'https://t.me/energosetmontaj',
    // instagram: 'https://instagram.com/energosetmontaj',
    // youtube: 'https://instagram.com/energosetmontaj',
    facebook: 'https://instagram.com/energosetmontaj',
  },
};

export const ServicesData = [
  {
    id: 1,
    title: 'power_line_construction',
    desc: 'power_line_construction_desc',
    description: [
      { id: 1, text: 'design_desc' },
      { id: 2, text: 'construction_desc' },
      { id: 3, text: 'commissioning_desc' },
    ],
    image: '/services/services-1.webp',
    images: [
      { id: 1, image: '/services/services-1-1.webp' },
      { id: 2, image: '/services/services-1-2.webp' },
      { id: 3, image: '/services/services-1-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'design_phase',
        icon: 1,
        image: '/services/services-1-4.webp',
      },
      {
        id: 2,
        title: 'construction_phase',
        icon: 2,
        image: '/services/services-1-5.webp',
      },
      {
        id: 3,
        title: 'commissioning_phase',
        icon: 3,
        image: '/services/services-1-6.webp',
      },
      {
        id: 4,
        title: 'maintenance_phase',
        icon: 4,
        image: '/services/services-1-7.webp',
      },
    ],
  },
  {
    id: 2,
    title: 'power_line_installation',
    desc: 'power_line_installation_desc',
    image: '/services/services-2.webp',
    description: [
      { id: 1, text: 'inspection_preparation_desc' },
      { id: 2, text: 'disconnection_safety_desc' },
      { id: 3, text: 'installation_dismantling_desc' },
    ],
    images: [
      { id: 1, image: '/services/services-2-1.webp' },
      { id: 2, image: '/services/services-2-2.webp' },
      { id: 3, image: '/services/services-2-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'inspection_preparation_title',
        icon: 1,
        image: '/services/services-2-4.webp',
      },
      {
        id: 2,
        title: 'disconnection_safety_title',
        icon: 2,
        image: '/services/services-2-5.webp',
      },
      {
        id: 3,
        title: 'installation_dismantling_title',
        icon: 3,
        image: '/services/services-2-6.webp',
      },
      {
        id: 4,
        title: 'testing_title',
        icon: 4,
        image: '/services/services-2-7.webp',
      },
    ],
  },
  {
    id: 3,
    title: 'substation_construction',
    desc: 'substation_construction_desc',
    image: '/services/services-3.webp',
    description: [
      { id: 1, text: 'substation_design_desc' },
      { id: 2, text: 'substation_preparation_desc' },
      { id: 3, text: 'substation_equipment_desc' },
    ],
    images: [
      { id: 1, image: '/services/services-3-1.webp' },
      { id: 2, image: '/services/services-3-2.webp' },
      { id: 3, image: '/services/services-3-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'substation_design_title',
        icon: 1,
        image: '/services/services-3-4.webp',
      },
      {
        id: 2,
        title: 'substation_preparation_title',
        icon: 2,
        image: '/services/services-3-5.webp',
      },
      {
        id: 3,
        title: 'substation_equipment_title',
        icon: 3,
        image: '/services/services-3-6.webp',
      },
      {
        id: 4,
        title: 'substation_cabling_title',
        icon: 4,
        image: '/services/services-3-7.webp',
      },
      {
        id: 5,
        title: 'substation_commissioning_title',
        icon: 5,
        image: '/services/services-3-8.webp',
      },
    ],
  },
  {
    id: 4,
    title: 'substation_equipment_installation',
    desc: 'substation_equipment_installation_desc',
    image: '/services/services-4.webp',
    description: [
      { id: 1, text: 'equipment_inspection_desc' },
      { id: 2, text: 'equipment_installation_desc' },
      { id: 3, text: 'equipment_tuning_desc' },
    ],
    images: [
      { id: 1, image: '/services/services-4-1.webp' },
      { id: 2, image: '/services/services-4-2.webp' },
      { id: 3, image: '/services/services-4-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'equipment_inspection_title',
        icon: 1,
        image: '/services/services-4-4.webp',
      },
      {
        id: 2,
        title: 'equipment_installation_title',
        icon: 2,
        image: '/services/services-4-5.webp',
      },
      {
        id: 3,
        title: 'equipment_tuning_title',
        icon: 3,
        image: '/services/services-4-6.webp',
      },
      {
        id: 4,
        title: 'equipment_testing_title',
        icon: 4,
        image: '/services/services-4-7.webp',
      },
    ],
  },
  {
    id: 5,
    title: 'pole_production',
    desc: 'pole_production_desc',
    image: '/services/services-5.webp',
    description: [
      { id: 1, text: 'pole_design_desc' },
      { id: 2, text: 'pole_materials_desc' },
      { id: 3, text: 'pole_fabrication_desc' },
    ],
    images: [
      { id: 1, image: '/services/services-5-1.webp' },
      { id: 2, image: '/services/services-5-2.webp' },
      { id: 3, image: '/services/services-5-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'pole_design_title',
        icon: 1,
        image: '/services/services-5-4.webp',
      },
      {
        id: 2,
        title: 'pole_materials_title',
        icon: 2,
        image: '/services/services-5-5.webp',
      },
      {
        id: 3,
        title: 'pole_fabrication_title',
        icon: 3,
        image: '/services/services-5-6.webp',
      },
      {
        id: 4,
        title: 'pole_quality_title',
        icon: 4,
        image: '/services/services-5-7.webp',
      },
      {
        id: 5,
        title: 'pole_delivery_title',
        icon: 5,
        image: '/services/services-5-8.webp',
      },
    ],
  },
  {
    id: 6,
    title: 'concrete_product_manufacturing',
    desc: 'concrete_product_manufacturing_desc',
    image: '/services/services-6.webp',
    description: [
      { id: 1, text: 'rc_foundation_desc1' },
      { id: 2, text: 'rc_foundation_desc2' },
      { id: 3, text: 'rc_foundation_desc3' },
    ],
    images: [
      { id: 1, image: '/services/services-6-1.webp' },
      { id: 2, image: '/services/services-6-2.webp' },
      { id: 3, image: '/services/services-6-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'rc_stage1',
        icon: 1,
        image: '/services/services-6-4.webp',
      },
      {
        id: 2,
        title: 'rc_stage2',
        icon: 2,
        image: '/services/services-6-5.webp',
      },
      {
        id: 3,
        title: 'rc_stage3',
        icon: 3,
        image: '/services/services-6-6.webp',
      },
      {
        id: 4,
        title: 'rc_stage4',
        icon: 4,
        image: '/services/services-6-7.webp',
      },
      {
        id: 5,
        title: 'rc_stage5',
        icon: 5,
        image: '/services/services-6-8.webp',
      },
    ],
  },
  {
    id: 7,
    title: 'hazardous_title',
    desc: 'hazardous_desc',
    image: '/services/services-7.webp',
    description: [
      { id: 1, text: 'strict_design_desc' },
      { id: 2, text: 'strict_construction_desc' },
      { id: 3, text: 'strict_delivery_desc' },
    ],
    images: [
      { id: 1, image: '/services/services-7-1.webp' },
      { id: 2, image: '/services/services-7-2.webp' },
      { id: 3, image: '/services/services-7-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'strict_design_title',
        icon: 1,
        image: '/services/services-7-4.webp',
      },
      {
        id: 2,
        title: 'strict_construction_title',
        icon: 2,
        image: '/services/services-7-5.webp',
      },
      {
        id: 3,
        title: 'strict_delivery_title',
        icon: 3,
        image: '/services/services-7-6.webp',
      },
    ],
  },
  {
    id: 8,
    title: 'custom_title',
    desc: 'custom_intro',
    image: '/services/services-8.webp',
    description: [
      { id: 1, text: 'custom_stage1_desc' },
      { id: 2, text: 'custom_stage2_desc' },
      { id: 3, text: 'custom_stage3_desc' },
    ],
    images: [
      { id: 1, image: '/services/services-8-1.webp' },
      { id: 2, image: '/services/services-8-2.webp' },
      { id: 3, image: '/services/services-8-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'custom_stage1_title',
        icon: 1,
        image: '/services/services-8-4.webp',
      },
      {
        id: 2,
        title: 'custom_stage2_title',
        icon: 2,
        image: '/services/services-8-5.webp',
      },
      {
        id: 3,
        title: 'custom_stage3_title',
        icon: 3,
        image: '/services/services-8-6.webp',
      },
    ],
  },
  {
    id: 9,
    title: 'supply_delivery_title',
    desc: 'supply_delivery_description',
    image: '/services/services-9.webp',
    description: [
      { id: 1, text: 'logistics_desc1' },
      { id: 2, text: 'logistics_desc2' },
      { id: 3, text: 'logistics_desc3' },
    ],
    images: [
      { id: 1, image: '/services/services-9-1.webp' },
      { id: 2, image: '/services/services-9-2.webp' },
      { id: 3, image: '/services/services-9-3.webp' },
    ],
    stages: [
      {
        id: 1,
        title: 'logistics_stage1',
        icon: 1,
        image: '/services/services-9-4.webp',
      },
      {
        id: 2,
        title: 'logistics_stage2',
        icon: 2,
        image: '/services/services-9-5.webp',
      },
      {
        id: 3,
        title: 'logistics_stage3',
        icon: 3,
        image: '/services/services-9-6.webp',
      },
      {
        id: 4,
        title: 'logistics_stage4',
        icon: 4,
        image: '/services/services-9-7.webp',
      },
    ],
  },
];

export const navLinks = [
  {
    path: '/',
    title: 'home',
  },
  {
    path: '/about',
    title: 'about_us',
  },
  {
    path: '/services',
    title: 'activity_types',
  },
  {
    path: '/projects',
    title: 'projects',
  },
  {
    path: '/gallery',
    title: 'gallery',
  },
  {
    path: '/news',
    title: 'news',
  },
  {
    path: '/contact',
    title: 'contact',
  },
];
export const langSwitchKey = [
  {
    id: 0,
    title: 'UZB',
    key: 'uz',
    image: '/langs/uz.svg',
  },
  {
    id: 1,
    title: 'RUS',
    key: 'ru',
    image: '/langs/ru.svg',
  },
  {
    id: 2,
    title: 'ENG',
    key: 'en',
    image: '/langs/en.svg',
  },
  {
    id: 3,
    title: 'CHN',
    key: 'cn',
    image: '/langs/cn.svg',
  },
];

export const WhyUsData = [
  {
    id: 1,
    title: 'guaranteed_quality',
    desc: 'guaranteed_quality_desc',
    icon: ShieldCheck,
  },
  {
    id: 2,
    title: 'professional_team',
    desc: 'professional_team_desc',
    icon: Users,
  },
  {
    id: 3,
    title: 'modern_technologies',
    desc: 'modern_technologies_desc',
    icon: UtilityPole,
  },
  {
    id: 4,
    title: 'on_time',
    desc: 'on_time_desc',
    icon: CalendarCheck,
  },
];

export const statistics = [
  {
    id: 1,
    img: '/stats/stats-1.png',
    title: 'years_experience',
    number: 16,
  },
  {
    id: 2,
    img: '/stats/stats-2.png',
    title: 'successful_projects',
    number: 500,
  },
  {
    id: 3,
    img: '/stats/stats-3.png',
    title: 'professionals',
    number: 45,
  },
  {
    id: 4,
    img: '/stats/stats-4.png',
    title: 'equipment',
    number: 20,
  },
];

export const NewsData = [
  {
    id: 1,
    date: '11/01/2025',
    images: '/services/services-5.webp',
    title:
      'titletitle title title title title titletitle title title titletitle title title',
    desc: 'guaranteed_quality_desc',
  },
  {
    id: 2,
    date: '11/01/2025',
    images: '/services/services-5.webp',
    title:
      'titletitle title title title title titletitle title title titletitle title title',
    desc: 'professional_team_desc',
  },
  {
    id: 3,
    date: '11/01/2025',
    images: '/services/services-5.webp',
    title:
      'titletitle title title title title titletitle title title titletitle title title',
    desc: 'modern_technologies_desc',
  },
  {
    id: 4,
    date: '11/01/2025',
    images: '/services/services-5.webp',
    title:
      'titletitle title title title title titletitle title title titletitle title title',
    desc: 'on_time_desc',
  },
];
export const Documents = [
  {
    id: 1,
    icon: '/file-icons/pdf.png',
    doc: '/certificates/certificate-1.pdf',
    title: 'certificate_first',
    size: '250 kb',
  },
  {
    id: 2,
    icon: '/file-icons/pdf.png',
    doc: '/certificates/certificate-2.pdf',
    title: 'certificate_second',
    size: '175 kb',
  },
  {
    id: 3,
    icon: '/file-icons/pdf.png',
    doc: '/certificates/certificate-3.pdf',
    title: 'certificate_third',
    size: '787 kb',
  },
];

export const GalleryImagesArray = [
  {
    id: 1,
    src: '/gallery/img-1.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 2,
    src: '/gallery/img-2.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 3,
    src: '/gallery/img-3.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 4,
    src: '/gallery/img-4.webp',
    alt: 'tower',
    style: 'sm:col-span-2 sm:row-span-2 row-span-1 col-span-2',
  },
  {
    id: 5,
    src: '/gallery/img-5.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 6,
    src: '/gallery/img-6.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 7,
    src: '/gallery/img-7.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 8,
    src: '/gallery/img-8.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  //   Other half
  {
    id: 9,
    src: '/gallery/img-9.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-2',
  },
  {
    id: 10,
    src: '/gallery/img-10.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 11,
    src: '/gallery/img-11.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 12,
    src: '/gallery/img-12.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 13,
    src: '/gallery/img-13.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-2',
  },
  {
    id: 14,
    src: '/gallery/img-14.webp',
    alt: 'tower',
    style: 'sm:col-span-2 sm:row-span-2 row-span-1 col-span-1',
  },
  {
    id: 15,
    src: '/gallery/img-15.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 16,
    src: '/gallery/img-16.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 17,
    src: '/gallery/img-17.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 18,
    src: '/gallery/img-18.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 19,
    src: '/gallery/img-19.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 20,
    src: '/gallery/img-20.webp',
    alt: 'tower',
    style: 'sm:col-span-2 sm:row-span-2 row-span-1 col-span-2',
  },
  {
    id: 21,
    src: '/gallery/img-21.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 22,
    src: '/gallery/img-22.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 23,
    src: '/gallery/img-23.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 24,
    src: '/gallery/img-24.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  //   Other half
  {
    id: 25,
    src: '/gallery/img-25.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-2',
  },
  {
    id: 26,
    src: '/gallery/img-26.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 27,
    src: '/gallery/img-27.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 28,
    src: '/gallery/img-28.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 29,
    src: '/gallery/img-29.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-2',
  },
  {
    id: 30,
    src: '/gallery/img-30.webp',
    alt: 'tower',
    style: 'sm:col-span-2 sm:row-span-2 row-span-1 col-span-1',
  },
  {
    id: 31,
    src: '/gallery/img-31.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 32,
    src: '/gallery/img-32.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },

  {
    id: 33,
    src: '/gallery/img-33.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 34,
    src: '/gallery/img-34.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 35,
    src: '/gallery/img-35.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 36,
    src: '/gallery/img-36.webp',
    alt: 'tower',
    style: 'sm:col-span-2 sm:row-span-2 row-span-1 col-span-2',
  },
  {
    id: 37,
    src: '/gallery/img-37.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 38,
    src: '/gallery/img-38.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 39,
    src: '/gallery/img-39.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 40,
    src: '/gallery/img-40.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  //   Other half
  {
    id: 41,
    src: '/gallery/img-41.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-2',
  },
  {
    id: 42,
    src: '/gallery/img-42.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 43,
    src: '/gallery/img-43.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-1',
  },
  {
    id: 44,
    src: '/gallery/img-44.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
  {
    id: 45,
    src: '/gallery/img-45.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-2',
  },
  {
    id: 46,
    src: '/gallery/img-46.webp',
    alt: 'tower',
    style: 'sm:col-span-2 sm:row-span-2 row-span-1 col-span-1',
  },
  {
    id: 47,
    src: '/gallery/img-47.webp',
    alt: 'tower',
    style: 'sm:col-span-3 col-span-1',
  },
  {
    id: 48,
    src: '/gallery/img-48.webp',
    alt: 'tower',
    style: 'sm:col-span-2 col-span-2',
  },
];
